export default {
  summary: {
    delivery: 'Lieferung: Geschenkgutschein als PDF per E-Mail',
  },
};
